// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3QluV","name":"Header_name__2KBTl","birthday":"Header_birthday__3iMqG","skeleton":"Header_skeleton__18ldU"};